import { create } from "zustand";

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  /** “New backtest” dialog, rendered by Shell over whatever page is open. */
  newBacktestOpen: boolean;
  /** Pine source to prefill when the dialog opens (e.g. the onboarding example). */
  newBacktestSource: string;
  openNewBacktest: (source?: unknown) => void;
  closeNewBacktest: () => void;
  /** “Go live” dialog, rendered by Shell like New backtest; null while closed. */
  goLive: { backtestId: string } | null;
  /** Opens it, preselecting a lab backtest when given one. */
  openGoLive: (backtestId?: unknown) => void;
  closeGoLive: () => void;
}

export const useUiStore = create<UiState>()((set) => ({
  sidebarOpen: true,
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  newBacktestOpen: false,
  newBacktestSource: "",
  // Also used directly as an onClick handler, so ignore non-string arguments (events).
  openNewBacktest: (source) =>
    set({ newBacktestOpen: true, newBacktestSource: typeof source === "string" ? source : "" }),
  closeNewBacktest: () => set({ newBacktestOpen: false }),
  goLive: null,
  // Also used directly as an onClick handler, so ignore non-string arguments (events).
  openGoLive: (backtestId) => set({ goLive: { backtestId: typeof backtestId === "string" ? backtestId : "" } }),
  closeGoLive: () => set({ goLive: null }),
}));
